import { useEffect, useState } from "react";
import { ref } from "firebase/database";
import { listenDatabaseValue as onValue } from "../utils/listenDatabaseValue";
import { db } from "../lib/firebase";
import { getPathDatabaseByRole } from "../actions/auth";
import { useDispatchApp, useSelectorApp } from "../lib/redux";

/**
 * Fail-closed listener for `agencies/${agencyID}/showVerifySubscriptionModal`.
 * Hidden until RTDB returns an explicit `true` for the current agency. Slow
 * network, missing flag, agency switch, or a read error never open it.
 */
const useShowVerifySubscriptionModal = () => {
  const dispatch = useDispatchApp();
  const authUser = useSelectorApp((state) => state.auth.user);
  const { agencyID } = dispatch(getPathDatabaseByRole());
  const [flagState, setFlagState] = useState({
    agencyID: null,
    value: false,
    resolved: false,
  });

  useEffect(() => {
    if (!authUser?.uid || !agencyID) {
      setFlagState({
        agencyID: agencyID || null,
        value: false,
        resolved: false,
      });
      return undefined;
    }

    let cancelled = false;
    const flagRef = ref(db, `agencies/${agencyID}/showVerifySubscriptionModal`);

    const unsubscribe = onValue(
      flagRef,
      (snapshot) => {
        if (cancelled) return;
        setFlagState({
          agencyID,
          value: snapshot.val() === true,
          resolved: true,
        });
      },
      () => {
        if (cancelled) return;
        setFlagState({
          agencyID,
          value: false,
          resolved: true,
        });
      }
    );

    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, [authUser?.uid, agencyID]);

  const showVerifySubscriptionModal =
    Boolean(authUser?.uid) &&
    Boolean(agencyID) &&
    flagState.agencyID === agencyID &&
    flagState.resolved &&
    flagState.value === true;

  return {
    showVerifySubscriptionModal,
    showVerifySubscriptionModalResolved:
      flagState.agencyID === agencyID && flagState.resolved,
  };
};

export default useShowVerifySubscriptionModal;
